import LottieReact, { LottieComponentProps } from 'lottie-react';
import { useMemo } from 'react';

import LoadingLime from 'components/loading/animations/Loading-Lime.json';
import LoadingPrimary from 'components/loading/animations/Loading-Primary.json';
import LoadingSmartGray3 from 'components/loading/animations/Loading-Smart-Gray-3.json';
import LoadingSmartGray4 from 'components/loading/animations/Loading-Smart-Gray-4.json';

export interface LoadingAnimationProps extends Omit<
  LottieComponentProps,
  'animationData' | 'size'
> {
  animation?: 'lime' | 'primary' | 'smart-gray-3' | 'smart-gray-4';
  size?: 'small' | 'medium' | 'large';
}

const animationSize = {
  small: 16,
  medium: 24,
  large: 34,
};

export function LoadingAnimation({
  animation = 'primary',
  size = 'medium',
  ...props
}: LoadingAnimationProps) {
  const animationData = useMemo(() => {
    switch (animation) {
      case 'lime':
        return LoadingLime;
      case 'primary':
        return LoadingPrimary;
      case 'smart-gray-3':
        return LoadingSmartGray3;
      case 'smart-gray-4':
        return LoadingSmartGray4;
      default:
        return LoadingPrimary;
    }
  }, [animation]);
  return (
    <LottieReact
      {...props}
      animationData={animationData}
      size={animationSize[size]}
      role="status"
      aria-label="Loading"
    />
  );
}
